import { PlanType, UserSubscription } from './subscription'

export enum ModuleType {
  HOME = 'home',
  PATIENTS = 'patients',
  BLOT_ANALYSIS = 'blot_analysis',
  TELEEXPERTISE = 'teleexpertise', // Same as collaboratory - legacy name
  LAB = 'lab',
  LITERATURE_WATCH = 'literature_watch',
  TRAINING = 'training',
  ADMIN = 'admin',
}

export interface IUserModule {
  id: string
  userId: string
  moduleType: ModuleType
  isEnabled: boolean
  permissions?: string[]
  createdAt: string
  updatedAt: string
}

export interface IModuleConfig {
  type: ModuleType
  label: string
  icon: React.ReactElement
  href: string
  ariaLabel: string
  description?: string
  requiredRole?: string[]
  subModules?: IModuleConfig[]
  hideFromSidebar?: boolean // Hide from sidebar if accessed through parent module
}

export interface IUserWithModules {
  id: string
  email: string
  companyName: string
  contactName: string
  phoneNumber: string
  specialtyId: string
  verifiedAt: string
  createdAt: string
  updatedAt: string
  location: any
  fullAddress: string
  specialty?: any
  adeliFinessNumber?: string
  rppsNumber?: string
  avatarUrl?: string
  avatarFilePath?: string
  modules: IUserModule[]
  role?: string
  plan?: PlanType
  subscription?: UserSubscription
  accessExpiresAt?: string | null
  invitedBy?: { contactName: string | null; email: string; companyName: string | null } | null
  canChangePlan?: boolean
}